/* global axios */
import ApiClient from '../ApiClient';

class KnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('my_ai/assistants', { accountScoped: true });
  }

  base(assistantId) {
    return `${this.url}/${assistantId}/knowledge_base`;
  }

  summary(assistantId, signal) {
    return axios.get(this.base(assistantId), { signal });
  }

  records(assistantId, params, signal) {
    return axios.get(`${this.base(assistantId)}/records`, { params, signal });
  }

  proposals(assistantId, signal) {
    return axios.get(`${this.base(assistantId)}/proposals`, { signal });
  }

  action(assistantId, action, data = {}) {
    return axios.post(`${this.base(assistantId)}/${action}`, data);
  }

  history(assistantId, recordId) {
    return axios.get(`${this.base(assistantId)}/history`, {
      params: { record_id: recordId },
    });
  }
}

export default new KnowledgeBaseAPI();
